import { Injectable, OnDestroy, inject } from '@angular/core';

import { ApDarkmodeService } from '@ap/darkmode';

import { ApWebContainerService } from '../web-container.service';
import { NativeAppearanceSettingOptions } from '../web-container.model';

@Injectable()
export class ApWebcontainerDarkmodeService implements OnDestroy {
    private readonly webcontainer = inject(ApWebContainerService);
    private readonly asnDarkModeService = inject(ApDarkmodeService);
    private initialized = false;

    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    private themeHandler = (mode: 'light' | 'dark') => {};

    /**
     * Initializes darkmode. Checks webcontainer for appearance setting
     * and sets darkmode accordingly
     */
    public initDarkmode() {
        if (!this.initialized) {
            this.webcontainer.getAppearanceSetting().subscribe((data) => {
                const s = data.setting as any;

                if (s === 'automatic' || s === NativeAppearanceSettingOptions.AUTOMATIC) {
                    this.asnDarkModeService.initializeAutomaticDarkmode();
                } else if (s === NativeAppearanceSettingOptions.LIGHT || s === NativeAppearanceSettingOptions.DARK) {
                    this.asnDarkModeService.setDarkmode(s);
                }
            });

            this.initialized = true;
        }
    }

    /**
     * Angular lifecycle method. Clears subscriptions
     */
    public ngOnDestroy(): void {
        this.asnDarkModeService.unsubscribe(this.themeHandler);
    }
}
